import logo from '@~assets/logo/static.png';

export const StaticLogo = () => {
  return <img src={logo} width={150} alt="Aurous Finance" />;
};
